const abilityLevels = [
  {
    label: "Básico",
    value: "BASIC",
  },
  {
    label: "Intermediário",
    value: "INTERMEDIATE",
  },
  {
    label: "Avançado",
    value: "ADVANCED",
  },
];

export default abilityLevels;
